import {EditorSDK} from '@wix/platform-editor-sdk';

import {openDashboardModal} from '@/panels';
import {MultilingualDashboardUrlPath, MultilingualPages} from '@/types';

type OpenDashboardPayload = {
  pageToOpen?: MultilingualPages;
  currentLanguage?: string;
  sidePanelSection?: string;
};

const PAGE_TO_URL_MAP: Record<MultilingualPages, MultilingualDashboardUrlPath> = {
  [MultilingualPages.MANAGE_LANGUAGES]: MultilingualDashboardUrlPath.MANAGE_LANGUAGES,
  [MultilingualPages.TRANSLATION_MANAGER]: MultilingualDashboardUrlPath.TRANSLATION_MANAGER,
  [MultilingualPages.SETTINGS]: MultilingualDashboardUrlPath.SETTINGS,
  [MultilingualPages.ONBOARDING]: MultilingualDashboardUrlPath.ONBOARDING,
  [MultilingualPages.PACKAGE_PICKER]: MultilingualDashboardUrlPath.PACKAGE_PICKER,
};

export const handleOpenDashboard = (
  editorSDK: EditorSDK,
  token: string,
  openDashboardPayload?: OpenDashboardPayload,
) => {
  const {pageToOpen, currentLanguage, sidePanelSection} = openDashboardPayload ?? {};

  const dashboardUrlToOpen =
    PAGE_TO_URL_MAP[pageToOpen!] ?? MultilingualDashboardUrlPath.TRANSLATION_MANAGER;

  openDashboardModal(editorSDK, token, dashboardUrlToOpen, {
    ...(currentLanguage && {secondaryLanguage: currentLanguage}),
    ...(sidePanelSection && {sidePanelSection}),
  });
};
